/** Compact, monochrome symbols for the vehicle's primary navigation. */
export function MenuIcon({name}:{name:"maintenance"|"vehicles"}) {
 return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-menu-icon={name}>
  {name==="maintenance" ? <><rect x="4" y="5" width="16" height="16" rx="2"/><path d="M8 3v4m8-4v4M4 10h16m-12 5 3 3 5-5"/></> : <><path d="m5 10 2-5h10l2 5M4 10h16l1 3v6H3v-6Zm1 9v2m14-2v2M6 14h2m8 0h2M9 18h6"/></>}
 </svg>;
}
